import {Skeleton, Paper} from '@mui/material'
import React from 'react'

interface ProductionPlanningSkeletonProps {
  height: number | string
  variant?: 'rectangular' | 'rounded' | 'text' | 'circular'
  /** Render on a `Paper` surface (page-level skeletons). Defaults to `true`. */
  withPaper?: boolean
}

export const ProductionPlanningSkeleton: React.FC<ProductionPlanningSkeletonProps> = ({
  height,
  variant = 'rectangular',
  withPaper = true
}) => (
  <Skeleton
    variant={variant}
    component={withPaper ? Paper : 'div'}
    sx={{
      height,
      backgroundColor: ({palette}) => palette.background.paper
    }}
  />
)
